// if(window.location.href.indexOf("app.tianxia120.com/member") != -1){
//     window.location.href='https://app.tianxia120.com/member/#/'
// }
import search from '../util/fetch'

// const baseUrl = 'http://192.168.0.86:8080/cat'; //本地
// const baseUrl = 'http://192.168.0.211/cat'; //测试
const baseUrl = 'https://app.tianxia120.com/cat'; //正式

// console.log(baseUrl)
//会员管家下载
export function downlodePc (obj) {  //定义函数
  return search({     //是axios返回的参数   返回的是一个promise
    url: `${baseUrl}/appUpgrade/getVersion`,
    method: "POST",
    data: obj
  })
}

//获取验证码
export function getcode (obj) {  //定义函数
  return search({     //是axios返回的参数   返回的是一个promise
    url: baseUrl + '/register/smsCode6',
    method: "POST",
    data: obj
  })
}

//会员管家申请
export function joinuserList (obj) {  //定义函数
  return search({     //是axios返回的参数   返回的是一个promise
    url: `${baseUrl}/accountApply/uploadInfo`,
    method: "POST",
    data: obj
  })
}

//查询所有省市县
export function checkAddress (obj) {  //定义函数
  return search({     //是axios返回的参数   返回的是一个promise
    url: `${baseUrl}/baseArea/getBaseAreaByParent`,
    method: "POST",
    data: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js